export default __webpack_public_path__ + "static/media/no-subjects.e074f824.svg";